/* eslint-disable @typescript-eslint/explicit-function-return-type */
import {
  ComboBox,
  Container,
  Heading,
  type IItem,
  Text,
} from "@fluidattacks/design";
import type { FC } from "react";
import { Fragment, useCallback, useState } from "react";
import { useTranslation } from "react-i18next";
import { useTheme } from "styled-components";

import { StyledGrid, StyledSelectorWrapper } from "./styles";
import type { IBranchesSectionProps } from "./types";

const BranchesSection: FC<IBranchesSectionProps> = ({
  repositories,
  urls,
  control,
  setValue,
}): JSX.Element => {
  const { t } = useTranslation();
  const theme = useTheme();

  const [defaultBranch, setDefaultBranch] = useState("");

  const handleChange = useCallback(
    (index: number, items: IItem[]) => {
      return (value: string): void => {
        setDefaultBranch(value);
        setValue(`branches.${index}`, value);
        if (items.some((item) => item.value === value)) {
          setDefaultBranch("");
        }
      };
    },
    [setValue],
  );

  return (
    <Container
      bgColor={"#ffffff"}
      border={"1px solid #f4f4f6"}
      borderRadius={"4px"}
      maxWidth={"100%"}
      mt={0.625}
      px={1.5}
      py={1.5}
      width={"100%"}
    >
      <Text color={theme.palette.primary[400]} mb={1.5} size={"md"}>
        {t("components.oauthRootForm.steps.s2.note")}
      </Text>
      <Fragment>
        {urls.map((url, index) => {
          const items = (urlRepo: string): IItem[] =>
            repositories[urlRepo].branches.map(
              (branch: string): IItem => ({
                name: branch.toLowerCase(),
                value: branch,
              }),
            );

          return (
            <StyledGrid key={url}>
              <Heading fontWeight={"bold"} mr={0.5} size={"xs"}>
                {repositories[url].name}
              </Heading>
              <StyledSelectorWrapper>
                <ComboBox
                  control={control}
                  items={[
                    { name: defaultBranch, value: defaultBranch },
                    ...items(url),
                  ]}
                  label={"Branch"}
                  name={`branches.${index}`}
                  onChange={handleChange(index, items(url))}
                />
              </StyledSelectorWrapper>
            </StyledGrid>
          );
        })}
      </Fragment>
    </Container>
  );
};

export { BranchesSection };
